import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import InvoiceIncomingExtendedRowButtonArea from '@/views/my-projects/components/invoices/InvoiceIncomingExtendedRowButtonArea.vue';
import InvoiceIncomingExtendedRowBaseData from '@/views/my-projects/components/invoices/InvoiceIncomingExtendedRowBaseData.vue';
import InvoiceAttachmentFileTable from '@/views/my-projects/components/invoice/attachments/InvoiceAttachmentFileTable.vue';
import { ComponentInvoice } from '@/models/Invoice';
import useUser from '@/mixins/useUser';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { logError } from '@/utils/logger';
import useMessengerState from '@/state/messenger/messengerState';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import X from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceIncomingExtendedRow',
  props: {
  invoice: {
    type: Object as PropType<ComponentInvoice>,
    default: null
  },
  helpText: {
    type: String,
    default: ''
  },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

const { tUserFallback: t } = useUser('self');
const { invoices, events } = useInvoice();
const { createNewChat, isOpened } = useMessengerState();
const isHelpOpen = ref(false);




const files = computed(() => {
  const invoice = invoices.value.find((i) => i.invoiceId === props.invoice?.invoiceId);
  return invoice?.attachments || [];
});

async function onChat() {
  if (props.invoice) {
    isOpened.value = true;
    try {
      await createNewChat(props.invoice.user);
    } catch (e: any) {
      logError('Error creating chat:', e);
    }
  }
}

function onClose() {
  emit('close');
}

return { __sfc: true,t, invoices, events, createNewChat, isOpened, isHelpOpen, emit, props, files, onChat, onClose, BCXUserBanner, InvoiceIncomingExtendedRowButtonArea, InvoiceIncomingExtendedRowBaseData, InvoiceAttachmentFileTable, BCXHelpTextTriggerIcon, BCXInfoCollapsible, X }
}

})